<script>
	import { onMount, onDestroy } from "svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../../../components/PageHeader/PageHeader.svelte";
	import SizeSelect from "../../../../../components/SizeSelect/SizeSelect.svelte";
	import MainIssueTable from "./MainIssueTable.svelte";
	import queryString from "query-string";
	import ErrorMessageHandler from "../../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import client from "src/services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
	} from "../../../../../store/store";
	import { get } from "svelte/store";
	import { field } from "svelte-forms";
	import CustomDatePicker from "../../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomButton from "../../../../../components/CustomButton/CustomButton.svelte";
	import { navigate } from "svelte-routing";

	const query = queryString.parse(window.location.search);

	const vehicleNumber = field("vehicleNumber", query.vehicleNumber || "");

	let startDate;
	let endDate;

	let startDateRangeError = "";
	let endDateRangeError = "";

	const handleSubmit = () => {
		const values = {
			vehicleNumber: $vehicleNumber.value,
			startDateRange: startDate ? startDate : "",
			endDateRange: endDate ? endDate : "",
		};

		let params = {};
		for (let key in values) {
			if (values[key] && values[key] !== "") {
				params[key] = values[key];
			}
		}

		var newRelativePathQuery =
			window.location.pathname + "?" + new URLSearchParams(params);

		window.location.replace(window.location.origin + newRelativePathQuery);
	};

	let data = [];
	onMount(async () => {
		document.body.scrollIntoView();
		try {
			loading.set(true);
			const res = await client("/v0/Issue/v2/GetVehicleIssueOverview", {
				method: "POST",
				version: "Tasking",
				data: {
					vehicleNumber: !query.vehicleNumber
						? ""
						: query.vehicleNumber.trim(),
					limit: get(sizeSelect),
					page: query.page,
					startDate: query.startDateRange,
					endDate: query.endDateRange,
				},
			});
			data = res.data.data.vehicleIssues;

			totalPages.set(res.data.data.totalPages);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);
			console.log(err.response);
			// errorMessage.set(err.response.data.errors[""]["0"]);
		}
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	const trigerSelectIssue = async () => {
		try {
			loading.set(true);
			const res = await client("/v0/Issue/v2/GetVehicleIssueOverview", {
				method: "POST",
				version: "Tasking",
				data: {
					vehicleNumber: !query.vehicleNumber
						? ""
						: query.vehicleNumber.trim(),
					limit: get(sizeSelect),
					page: query.page,
					startDate: query.startDateRange,
					endDate: query.endDateRange,
				},
			});
			data = res.data.data.vehicleIssues;

			const beforeFilterTotalPages = $totalPages;
			totalPages.set(res.data.data.totalPages);
			const afterFilterTotalPages = $totalPages;
			const currentPage = searchParams.get("page");

			if (
				afterFilterTotalPages < beforeFilterTotalPages &&
				currentPage > afterFilterTotalPages
			) {
				searchParams.set("page", 1);
				var newRelativePathQuery =
					window.location.pathname + "?" + searchParams.toString();
				navigate(newRelativePathQuery);
				window.location.reload();
			} else {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			console.log(err);
			console.log(err.response);
		}
	};

	const validateStartDateRange = () => {
		if (startDate > new Date().toISOString().slice(0, 10)) {
			startDateRangeError = "Start date cannot be after today's date!";
		} else if (startDate > endDate && startDate != "" && endDate != "") {
			startDateRangeError = "Start date cannot be after the end date!";
		} else {
			startDateRangeError = "";
		}
	};

	const validateEndDateRange = () => {
		if (endDate > new Date().toISOString().slice(0, 10)) {
			endDateRangeError = "End date cannot be after today's date!";
		} else if (endDate < startDate && startDate != "" && endDate != "") {
			endDateRangeError = "End date cannot be before the start date!";
		} else {
			endDateRangeError = "";
		}
	};

	onDestroy(() => {
		initPage.set(1);
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Vehicle Issues" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={7}>
					<form
						on:submit|preventDefault={startDateRangeError == "" &&
						endDateRangeError == ""
							? handleSubmit
							: null}
						class="w-100"
					>
						<Row class="my-2">
							<Col xs={4}>
								<input
									type="text"
									class="form-control getgo input"
									name="vehicleNumber"
									placeholder="Search by vehicle no."
									aria-label="Search by vehicle no."
									bind:value={$vehicleNumber.value}
								/>
							</Col>
							<Col xs={4}>
								<CustomDatePicker
									isRange={true}
									placeholder="Select a date range"
									value={startDate && endDate
										? [startDate, endDate]
										: ""}
									onChange={(e) => {
										startDate = e.detail[0];
										endDate = e.detail[1];
									}}
									name="dateRange"
								/>
							</Col>
							<Col xs={3} class="d-flex align-self-end my-1">
								<CustomButton
									buttonText="Search"
									type="submit"
								/>
							</Col>
						</Row>
					</form>
				</Col>
				<Col class="d-flex justify-content-end" xs={5}>
					<div class="d-flex align-items-center">
						<SizeSelect trigerSelect={trigerSelectIssue} />
					</div>
				</Col>
			</div>
		</div>
	</Col>
	<Col class="my-2">
		<MainIssueTable {data} />
	</Col>
</Row>
